import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { NgSelectModule } from "@ng-select/ng-select";

//Services
import { EspecialidadesService } from "src/app/core/services/especialidades.service";
import { EspecialistaService } from "src/app/core/services/especialista.service";
import { SedeService } from "src/app/core/services/sede.service";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { TiposEspecialistaService } from "src/app/core/services/tipo-especialista.service";

@Component({
  selector: "app-form-solicitud",
  standalone: true,
  imports: [NgSelectModule, FormsModule, CommonModule, RouterModule],
  templateUrl: "./form-solicitud.component.html",
  styleUrl: "./form-solicitud.component.scss",
})
export class FormSolicitudComponent {
  spinner: Boolean = true;
  especialistasFiltrados = [];
  tiposEspecialistas = [];
  especialidades = [];
  especialistas = [];
  convenios = [];
  servicios = [];
  sedes = [];

  //
  searchEspecialista: string = "";
  error = "";

  searchSede: string = "";
  searchServicio: string = "";
  searchEspecialidad: string = "";
  searchTipoEspecialista: string = "";

  constructor(
    private __sedeService: SedeService,
    private __serviciosService: ServiciosService,
    private router: Router,
    private __especialidadesService: EspecialidadesService,
    private __tiposEspecialistaService: TiposEspecialistaService
  ) {}

  ngOnInit(): void {
    this.getSedes((data: any) => {
      this.sedes = data;
    });
    this.getServicios((data: any) => {
      this.servicios = data;
    });
    this.getEspecialidades((data: any) => {
      this.especialidades = data;
    });
    this.getTipoEspecialistas((data: any) => {
      console.log("📂 Documentos de tipo especialistas:", data.documents);
      this.tiposEspecialistas = data.documents;
    });
  }

  /**
   * @getSedes()
   * @param dataComp
   */
  getSedes(dataComp: any) {
    this.__sedeService.getSedes().then((data: any) => {
      console.log("📍 Sedes encontradas:", data);
      dataComp(data.documents);
    });
  }

  /**
   * @getServicios()
   * @param dataComp
   */
  getServicios(dataComp: any) {
    this.__serviciosService.getData().then((data: any) => {
      dataComp(data);
    });
  }

  /**
   * @getTipoEspecialistas()
   * @param dataComp
   */
  getTipoEspecialistas(dataComp: any) {
    this.__tiposEspecialistaService.getTiposDocumento().then((data: any) => {
      console.log("📘 Tipos de Especialistas recibidos:", data)
      dataComp(data);
    }).catch((err) => {
      console.error("❌ Error al cargar Tipos de Especialistas:", err);
    });
  }

  /**
   * @getEspecialidades()
   * @param dataComp
   */
  getEspecialidades(dataComp: any) {
    this.__especialidadesService.getData().then((data: any) => {
      dataComp(data);
    });
  }

  /**
   *
   */
  bucarEspecialista() {
    this.router.navigate(["/citas-new"], {
      queryParams: {
        sede: this.searchSede,
        servicio: this.searchServicio,
        especialidad: this.searchEspecialidad,
        tipoEspecialista: this.searchTipoEspecialista,
      },
    });
  }

  filtrarDatos() {
    this.spinner = true;
    this.spinner = false;
  }

  public genero = [
    { text: "Masculino", value: "M" },
    { text: "Femenino", value: "F" },
    { text: "Otro", value: "O" },
  ];

  buscarPorEspecialista(nombre: string) {
    this.error = "";
    if (nombre.trim()) {
      console.log("Buscando especialista:", nombre);

      this.router.navigate(["/citas-list"], {
        queryParams: {
          sede: this.searchSede,
          servicio: this.searchServicio,
          especialidad: this.searchEspecialidad,
          tipoEspecialista: this.searchTipoEspecialista,
          nombreEspecialista: nombre,
        },
      });

      // Aquí iría tu lógica de búsqueda, por ejemplo:
      // this.servicioDeEspecialistas.buscar(nombre).subscribe(resultados => {
      //   // Manejar los resultados
      // });
    } else {
      this.error = "Por favor, ingresa un nombre para buscar";
      console.log("Por favor, ingresa un nombre para buscar");
    }
  }
}
